import { useEffect, useRef } from "react";

export function useCallbackInstance(callback) {
  const ref = useRef(callback);

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  return ref;
}
